import { render, staticRenderFns } from "./LlmSuggestion.vue?vue&type=template&id=05c94774&scoped=true"
import script from "./LlmSuggestion.vue?vue&type=script&lang=js"
export * from "./LlmSuggestion.vue?vue&type=script&lang=js"
import style0 from "./LlmSuggestion.vue?vue&type=style&index=0&id=05c94774&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c94774",
  null
  
)

export default component.exports